import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SampleTaskNavigationService } from '../services/sample-task-navigation.service';
import { SamplingWorkspaceStore } from '../state/sampling-workspace-store';

@Component({
  selector: 'h3-sampling-nav-controls',
  templateUrl: './sampling-nav-controls.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class SamplingNavControlsComponent {
  private readonly store = inject(SamplingWorkspaceStore);
  private readonly navigationService = inject(SampleTaskNavigationService);
  private readonly taskPosition$ = this.store('position').$;
  private readonly taskCount$ = this.store('sample')('sampledTaskCount').$;

  navigateTo = this.navigationService.navigateTo.bind(this.navigationService);
  shouldDisablePrevious$ = this.taskPosition$.pipe(
    map((position) => position === 1),
  );
  shouldDisableNext$ = combineLatest([
    this.taskPosition$,
    this.taskCount$,
  ]).pipe(map(([position, taskCount]) => position === taskCount));
}
